import React, { useContext, useEffect, useState } from "react";
import Header from "../../../Components/Header/Header";
import InfoSettings from "../../../Components/Settings/InfoSetting";
import { AppContext } from "../../../Context/AppContext";
import { MODULES } from "../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../Routes/Routes";

const StoreSetting = (props) => {
	const { showToastMessage, modules } = useContext(AppContext);
	const [access, setAccess] = useState({});

	useEffect(getModuleAccess, [modules]);

	function getModuleAccess() {
		let access = getAccessByModuleName(modules, MODULES.CONFIG_STORE_SETTING);
		if (access) setAccess(access.permissions);
		if (access && !access.permissions.write_access) {
			showToastMessage(
				undefined,
				"You are not authorized to access.",
				"error",
				false
			);
			props.history.push("/profile");
		}
	}

	return (
		<React.Fragment>
			<Header title="Add Store"/>
			<InfoSettings module="add-store" />
		</React.Fragment>
	);
};
export default React.memo(StoreSetting);
